/**
 * parseMinutes
 *
 * Переводит число (единицы времени) в человекопонятную строку
 *
 * @param {Number}      value - единицы времени
 * @param {String}      mode  - тип единиц времени - минуты (min) или секунды (sec)
 *
 * @author Aleksandr Kopytenko <aleksandr.kopytenko@nami.ru>
 *
 * @returns {String}    "1 день 21 час 32 мин"
 *
 */

export default function parseMinutes(value, mode = 'min') {
    let rDays, rHours, rMinutes

    if (mode == 'min') {
        const t = 60 * 24

        const days = value / t
        rDays = Math.floor(days)

        const hours = ((days - rDays) * t) / 60
        rHours = Math.floor(hours)

        const minutes = (hours - rHours) * 60
        rMinutes = Math.floor(minutes)
    } else {
        let seconds = value

        rDays = (seconds / 86400) | 0 // 86400 секунд в дне
        seconds -= rDays * 86400

        rHours = (seconds / 3600) | 0 // 3600 секунд в часе
        seconds -= rHours * 3600

        rMinutes = (seconds / 60) | 0 // 60 секунд в минуте
        seconds -= rMinutes * 60
    }

    return {
        days: rDays,
        hours: rHours,
        minutes: rMinutes, 
        value: value
    }
}
